import { Eye, UserCog, Shield, Trash2 } from "lucide-react";
import type { ActionItem } from "@/components/ui/actions-dropdown";
import type { ActionSurface } from "./types";

export interface UnifiedUserActionsContext {
  surface: ActionSurface;
  /** "directory" users cannot manage console roles, only assign one. */
  hasConsoleAccess: boolean;
  onView: () => void;
  onManageRoles: () => void;
  onAssignRole: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const L = (s: ActionSurface, list: string, detail: string) =>
  s === "list" ? list : detail;

export function buildUnifiedUserActions(ctx: UnifiedUserActionsContext): ActionItem[] {
  const { surface } = ctx;
  const items: ActionItem[] = [];
  if (surface === "list") {
    items.push({ label: "View Details", icon: Eye, onClick: ctx.onView });
  }
  if (ctx.hasConsoleAccess) {
    items.push({ label: "Manage Roles", icon: Shield, onClick: ctx.onManageRoles });
  } else {
    items.push({ label: "Assign Role", icon: Shield, onClick: ctx.onAssignRole });
  }
  items.push(
    { label: L(surface, "Edit", "Edit User"), icon: UserCog, onClick: ctx.onEdit },
    { label: L(surface, "Delete", "Delete User"), icon: Trash2, onClick: ctx.onDelete, destructive: true },
  );
  return items;
}
